import React, { FunctionComponent, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Image } from '@chakra-ui/react';
import { assetPrefix } from '../../../../utils';
import { HomeValueContext } from './context';
import { ResidenceType } from './config';

export const CalculatorsHomeValueCta: FunctionComponent = () => {
  const { selectedResidenceType } = useContext(HomeValueContext);
  const { alt, src } = getSelectedResidenceTypeImageProps(selectedResidenceType);

  return (
    <div>
      <h2 className={`mb-8`}>
        <FormattedMessage
          id={`cta.header.no-result`}
          defaultMessage={'Zelf gemakkelijk je woningwaarde berekenen'}
        />
      </h2>
      <div className={`hidden md:block`}>
        <Image className={`w-full`} alt={alt} src={`${assetPrefix}${src}`}></Image>
      </div>
    </div>
  );
};

function getSelectedResidenceTypeImageProps(type: ResidenceType): { src: string; alt: string } {
  switch (type) {
    case 'Tussenwoning':
      return {
        src: '/assets/calculators/home-value/tussenwoning.png',
        alt: 'Tussenwoning'
      };

    case 'TweeOnderEinKapwoning':
      return {
        src: '/assets/calculators/home-value/tweeonder1kap.png',
        alt: 'Twee onder 1 kap'
      };

    case 'VrijstaandeWoning':
      return {
        src: '/assets/calculators/home-value/vrijstaand.png',
        alt: 'Vrijstaande woning'
      };

    case 'Hoekwoning':
      return {
        src: '/assets/calculators/home-value/hoekhuis.png',
        alt: 'Hoekhuis'
      };

    default:
      return {
        src: '/assets/calculators/home-value/apartement.png',
        alt: 'Apartement'
      };
  }
}
